import { FormSchemaType } from 'constants/forms';

export const BATCH_EXCLUDED_FIELD_TYPES = [
  FormSchemaType.TODAY_X_DAYS,
  FormSchemaType.DATE_X_BUSINESS_DAYS,
  FormSchemaType.HAND_WRITING_SIGNATURE,
  FormSchemaType.NOTARY_MULTILINE_TEXT,
  FormSchemaType.IMAGE,
];

export const BatchFieldLayout = {
  START_X: 50,
  START_Y: 50,
  ROW_STEP: 20,
  COLUMN_STEP: 200,
  ROWS_PER_COLUMN: 30,
  MAX_COLUMNS: 3,
};

export const BatchPanelLayout = {
  WIDTH: 320,
  ESTIMATED_HEIGHT: 680,
  ANCHOR_OFFSET: 8,
  VIEWPORT_GUTTER: 16,
};

export const BATCH_PANEL_DRAG_HANDLE_CLASS = 'batch-add-dynamic-fields-drag-handle';

export const BATCH_PANEL_CLOSE_KEY = 'Escape';

export const BATCH_PANEL_TITLE = 'Add Multiple Fields';
export const BATCH_PANEL_DONE_LABEL = 'Done';

export const BATCH_PANEL_HINT =
  'Click a field to add it. New fields line up at the top left of this page, clear of other fields. Drag the title to move this panel.';

export const BATCH_PANEL_EXCLUDED_HINT =
  'Tags, date offsets, signatures, notary text, and images need setup — use Add Dynamic Field for those.';
